// extracted by mini-css-extract-plugin
export default {"privacyPolictContainer":"PrivacyPolicy_privacyPolictContainer__04qhZ"};